import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { Axios } from './axios'

export const handleAxiosError = async (error: AxiosError) => {
  if (error.response?.status === 401 && window.location.pathname !== '/login') {
    toast.error('You need to log in')
    localStorage.clear()
    window.location.replace('/login')
    return
  }

  toast.error(error?.response?.data?.message ? error.response.data.message : error.message)

  throw Error
}
